// client/src/components/catalogoModelo/ImportarCatalogoCard.js
import React from 'react';
import { Package, Download, Loader2 } from 'lucide-react';
import { useTenantI18n } from '../../hooks/useAccounts';
import { formatCurrency } from '../../utils/formatters';

const ImportarCatalogoCard = ({ item, onImportar, isImporting }) => {
    // ✅ ACHADO: preço sugerido fixo em BRL — o item está prestes a virar
    // um serviço da PRÓPRIA conta (ver ServicoRow.js), então já faz
    // sentido mostrar na moeda dela, não na do catálogo global.
    const { currency, locale } = useTenantI18n();
    const preco = item.precoSugerido !== undefined && item.precoSugerido !== null
        ? formatCurrency(item.precoSugerido, currency, locale)
        : null;

    return (
        <div className="gallery-item-card">
            <div className="gallery-item-card__image-container">
                {item.imagemGaleria?.url ? (
                    <img src={item.imagemGaleria.url} alt={item.nome} />
                ) : (
                    <div className="panel-state-wrapper" style={{ minHeight: 120 }}>
                        <Package size={32} className="icon" />
                    </div>
                )}
            </div>
            <div className="gallery-item-card__body">
                <h5 title={item.nome}>{item.nome}</h5>
                <p>{item.categoriaNome}</p>
                <div className="tags-container">
                    <span className={`badge ${item.tipo === 'servico' ? 'badge-blue' : 'badge-purple'}`}>
                        {item.tipo === 'servico' ? 'Serviço' : 'Produto'}
                    </span>
                    {preco && <span className="badge badge-gray">{preco}</span>}
                </div>
                <button
                    type="button"
                    onClick={() => onImportar(item)}
                    disabled={isImporting}
                    className="action-button action-button-primary"
                    style={{ marginTop: 10, width: '100%' }}
                >
                    {isImporting ? <Loader2 size={18} className="icon animate-spin" /> : <Download size={18} className="icon" />}
                    Importar
                </button>
            </div>
        </div>
    );
};

export default ImportarCatalogoCard;
